import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

/**
 * LegalShell — shared container for /terms and /privacy.
 * Keeps the dark aesthetic consistent with the landing page.
 */
const LegalShell = ({ testid, eyebrow, title, updated, children }) => {
  return (
    <div className="relative min-h-screen bg-[#050505]" data-testid={testid}>
      <Navbar />

      <main className="relative pt-32 pb-24 overflow-hidden">
        {/* ambient glow */}
        <div
          className="absolute -top-40 left-1/2 -translate-x-1/2 h-[420px] w-[720px] rounded-full bg-indigo-600/15 blur-[120px] pointer-events-none"
          aria-hidden="true"
        />
        <div className="absolute inset-0 grid-bg pointer-events-none opacity-60" aria-hidden="true" />

        <div className="relative max-w-3xl mx-auto px-6 lg:px-8">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500 hover:text-indigo-300 transition-colors"
          >
            <ArrowLeft className="h-3 w-3" strokeWidth={2} />
            Back to Equal
          </Link>

          <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-3 py-1">
            <span className="h-1.5 w-1.5 rounded-full bg-indigo-400 shadow-[0_0_10px_rgba(99,102,241,0.9)]" />
            <span className="font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-400">
              {eyebrow}
            </span>
          </div>

          <h1 className="mt-6 font-display font-semibold tracking-tighter text-white text-4xl md:text-5xl lg:text-6xl leading-[1.02]">
            {title}
          </h1>
          <p className="mt-4 font-mono uppercase tracking-[0.2em] text-[10.5px] text-zinc-500">
            Last updated · {updated}
          </p>

          <div className="mt-14 space-y-10 font-body text-[15px] md:text-[16px] leading-[1.75] text-zinc-300">
            {children}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalShell;
